var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1709_4246)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1709_4246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9655 5.90978H39.2163V2.5964C39.2161 1.49964 38.3476 0.609375 37.2788 0.609375C36.2078 0.609375 35.3414 1.49964 35.3414 2.5964V5.90978H17.9056V2.5964C17.9056 1.49964 17.0375 0.609375 15.9682 0.609375C14.8979 0.609375 14.0309 1.49964 14.0309 2.5964V5.90978H5.63462C4.56512 5.90978 3.69727 6.79989 3.69727 7.89681V50.9063C3.69727 52.0035 4.56512 52.8933 5.63462 52.8933H46.9655C48.0344 52.8933 48.9029 52.0035 48.9029 50.9063V7.89681C48.9027 6.79973 48.0344 5.90978 46.9655 5.90978ZM29.1435 44.8211H26.457V26.4055H26.3943L22.8217 28.3828L22.2839 26.2085L26.773 23.7462H29.1435V44.8211ZM45.0282 16.8381H7.57197V9.88367H14.0309V11.8705C14.0309 12.9675 14.8979 13.8576 15.9682 13.8576C17.0377 13.8576 17.9056 12.9675 17.9056 11.8705V9.88367H35.3414V11.8705C35.3414 12.9675 36.2078 13.8576 37.2788 13.8576C38.3476 13.8576 39.2161 12.9675 39.2161 11.8705V9.88367H45.0282V16.8381Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1709_4246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.2839,
    height: 52.2839,
    fill: "#4afc2d",
    transform: "translate(0.158203 0.984375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1709_4246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.9768,
    height: 52.2839,
    fill: "#4afc2d",
    transform: "translate(0.811523 0.609375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1071ab3e438c698093e4cd9372f523f3.svg";
export { ForwardRef as ReactComponent };